export default __webpack_public_path__ + "static/media/file-white.3ed06e74.svg";